import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05757afb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "borrow-applyDetail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "step1" }, "申请事项一", -1))
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "复核工商注册名称：", -1))
const _hoisted_5 = {
  class: "sign-table-wrapper",
  style: {"margin-left":"-10px"}
}

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import RisTable from "@/components/Table.vue";
import { getBusinessApplyFirstInfo } from "@/api/process_bussiness";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status", "set-workid"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }

const GsReviewBusRegisterName = ref<string>("");



const tableData = ref<
  { FileName?: string; AccessoryType: number; FileUrl?: string }[]
>([]);

watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);

onMounted(() => {
  getdata();
});
const getdata = async () => {
  const { Data } = await getBusinessApplyFirstInfo({
    BranchCompanyFlowId: props.folwId,
  });
  GsReviewBusRegisterName.value = Data?.PageData.GsReviewBusRegisterName || "";
  tableData.value = Data?.PageFiles;
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "工商设立申请",
      style: {"margin-top":"24px"}
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(_toDisplayString(GsReviewBusRegisterName.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(RisTable, { "table-data": tableData.value }, null, 8, ["table-data"])
      ])
    ])
  ], 64))
}
}

})